export const getBookIdFromNative = () => {
  let bookId = '';

  if (window.android) {
    bookId = window.JsTest.showToast("12312");
  }

  if (window.ios) {
    bookId = window.iOS_BookId;
  }

  return bookId;

}

// ---- web → native 橋接 ----
// App 端注入的名稱,雙方須一致
const IOS_MESSAGE_HANDLER = 'onebook';
const ANDROID_BRIDGE = 'NaniBridge';

export const NativeEvent = {
  // 請 App 關閉當前 webview
  CloseWebview: 'closeWebview',
};

// 往 native 送一次性事件;回傳是否真的送出(App 未注入橋接時為 false)
export const postToNative = (event, payload = {}) => {
  const message = { event, payload };

  if (window.ios) {
    const handler = window.webkit
      && window.webkit.messageHandlers
      && window.webkit.messageHandlers[IOS_MESSAGE_HANDLER];
    if (!handler) {
      console.warn(`[native] iOS messageHandler "${IOS_MESSAGE_HANDLER}" 未注入,${event} 未送出`);
      return false;
    }
    handler.postMessage(message);
    return true;
  }

  if (window.android) {
    const bridge = window[ANDROID_BRIDGE];
    // Android @JavascriptInterface 只能傳字串,統一序列化
    if (!bridge || typeof bridge.postMessage !== 'function') {
      console.warn(`[native] Android bridge "${ANDROID_BRIDGE}.postMessage" 未注入,${event} 未送出`);
      return false;
    }
    bridge.postMessage(JSON.stringify(message));
    return true;
  }

  return false;
};
